/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "GO EYEWEAR BLUERAY BLOCK UV PROTECTED COMPUTER GLASSES",
    img: "img/product-1.jpg",
    price: 345,
    company: "Go Eyewear",
    info:
      "Blue ray block computer glasses with UV block and anti reflection tecnology lenses provide maximum protection for your eyes Blue cut against the negative effectofthe blue light It absorbe UV light protecting the eye and making the use of electronic devices less inconvenint Go eyewear comes with a carring case and a micro fibre cleaning clouth",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "GO EYEWEAR Blueray Block Uv Square Frame (Unisex)",
    img: "img/product-2.jpg",
    price: 599,
    company: "Go Eyewear",
    info:
      "Premium Blue Ray Block Computer Glasses With Uv Block & Anti Reflection Tecnology Lenses Provide Maximum Protection For Your Eyes It Absorbe Uv Light Protecting The Eye And Making The Use Of Electronic Devices Less Inconvenint Blue Cut Against The Negative Effect of the Blue Light",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Amozo iPhone 11 Cases and Covers | AutoFocus Series Transparent Soft ",
    img: "img/product-3.jpg",
    price: 499,
    company: "Amozo",
    info:
      "QUALITY MATERIAL - Hybrid technology that is made of a TPU Material with a durable back panel CAMERA PROTECTION - Raised bezels lift camera off flat surfaces",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "JBL T460BT Extra Bass Wireless On-Ear Headphones with  Mic ",
    img: "img/product-4.png",
    price: 1999,
    company: "JBL",
    info:
      "Superior listening experience with JBL Pure Bass sound Wireless Bluetooth Streaming 11 hours of playtime under optimum audio settings Call and music controls on earcup Flat-foldable, lightweight and comfortable 1 year manufacturer’s warranty",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "JBL Flip 3 Stealth Waterproof Portable Bluetooth Speaker",
    img: "img/product-5.jpg",
    price: 5499,
    company: "JBL",
    info:
      "JBL Signature Sound Wireless Bluetooth streaming Dual external passive Bass radiators IPX7 Waterproof with durable fabric material 10 hours of playtime under optimum audio settings 1 year manufacturer’s warranty",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "boAt Rockerz 255 Pro Wireless Headset with ASAP Charge",
    img: "img/product-6.jpg",
    price: 999,
    company: "Boat",
    info:
      "boAt Rockerz 255 while being lightweight in design pumps out your favourite tunes with powerful HD sound and deep boosted bass Powered by Qualcomm QCC3003 chipset it offers high level functionality with the features of the latest Bluetooth V5.0 Its Fast Charging technology gives you the comfort of super quick full charge in only 1 hour The powerful 10mm dynamic driver uplifts the aura with its immersive audio output The wireless headset is IPX5 rated for protection against sweat and water scares cVc technology provides you with a seamless calling experience by offering clear and crisp voice Built with attractive ergonomics and uncompromised craftsmanship boAt Rockerz 255 Pro is both sturdy and stylishCountry of Origin: China",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Full Sleeve Casual Wear Mens Sky Blue Denim Jacket",
    img: "img/product-7.jpg",
    price: 699,
    company: "experto",
    info:
      "Sleeve Type	Full Sleeve Color	Sky Blue Size	S, M, L, XL Occasion	Casual Wear Wash Care	Machine wash ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Calvin Klein Minimal women  Swiss Made Watch",
    img: "img/product-8.jpg",
    price: 15999,
    company: "Calvin klein watches",
    info:
      "Calvin Klein Minimal women Analogue Swiss Made Watch K3M214X1 ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 9,
    title: "Head Torch high light for jogging  in morning",
    img: "img/product-9.jpg",
    price: 845,
    company: "heado",
    info:
      "head torch is awesome!",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 10,
    title: "Calvin Klein Minimal Swiss Made Watch ",
    img: "img/product-10.jpg",
    price: 5599,
    company: "calvin klein watches",
    info:
      "Calvin klein stylish watch 34weff black (unisex)",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 11,
    title: "mozo table fan white colour  cool air  ",
    img: "img/product-11.jpeg",
    price: 1499,
    company: "mozo",
    info:
      "table fan is 34 cm long and 12 cm wide",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 12,
    title: "clarins products clarins oil",
    img: "img/product-12.jpg",
    price: 699,
    company: "clarins",
    info:
      "Superior quality and healthy for hair",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 13,
    title: "Calvin klein stylish watch 34weff black",
    img: "img/product-13.jpg",
    price: 5499,
    company: "Calvin klein watches",
    info:
      "Calvin klein stylish watch 34weff black (unisex)",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 14,
    title: "Walnut prices will be displyed per kg",
    img: "img/product-14.jpeg",
    price: 99,
    company: "lion",
    info:
      "healthy and fresh walnut ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 15,
    title: "Blue towels of set 3 with smooth fur",
    img: "img/product-15.jpg",
    price: 699,
    company: "towello",
    info:
      "smooth and nice towel with soft fur ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 16,
    title: "rucksack 35L black travelling bag",
    img: "img/product-16.jpg",
    price: 1999,
    company: "ruckie",
    info:
      "best rucksack for travelling",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.jpg",
  price: 34599,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
